module.exports = __webpack_public_path__ + "files/3ee99d653ee50bd1b7fd2112401709d7.png";